import { Component, computed, input } from '@angular/core';

/** How far something is. */
export type RidProgress = 'FINISHED' | 'IN_PROGRESS' | 'NOT_STARTED';

/** The color of the card the dot sits on. */
export type RidProgressDotTone = 'LIGHT' | 'GREEN' | 'AMBER';

/** A square showing how far a part of something is: checked when finished, an outline still to fill while in progress. The parent decides how big it is; the check and the corners scale along. */
@Component({
  selector: 'rid-progress-dot',
  template: `
    @if (progress() === 'FINISHED') {
      <!-- Font Awesome 4's check: Font Awesome's current checks are too thin at this size -->
      <svg class="size-[70%]" viewBox="121 153 1550 1550">
        <path
          fill="currentColor"
          d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
        />
      </svg>
    }
  `,
  host: {
    class: 'grid place-items-center rounded-[25%]',
    '[class]': 'classes()',
  },
})
export class RidProgressDot {
  progress = input.required<RidProgress>();
  tone = input<RidProgressDotTone>('LIGHT');

  protected readonly classes = computed(() => {
    const classes: Record<RidProgressDotTone, Record<RidProgress, string>> = {
      LIGHT: { FINISHED: 'bg-green-600 text-white', IN_PROGRESS: 'border-2 border-amber-400 bg-amber-400/20', NOT_STARTED: 'bg-slate-300' },
      GREEN: { FINISHED: 'bg-white text-green-600', IN_PROGRESS: 'border-2 border-amber-300 bg-black/10', NOT_STARTED: 'bg-black/15' },
      AMBER: {
        FINISHED: 'bg-green-600 text-white',
        IN_PROGRESS: 'border-2 border-amber-600 bg-amber-600/15',
        NOT_STARTED: 'bg-amber-600/30',
      },
    };
    return classes[this.tone()][this.progress()];
  });
}
